import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AIP from './AIP';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AIP));
